"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _CatalogGroupPage = require("CatalogGroupPage");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var qd = {};

function lastQueryForIdentifier(ident) {
  if (ident == 'search') {
    var cookieData;

    if (typeof document != 'undefined' && document.cookie) {
      cookieData = document.cookie.split(/\s*;\s*/).map(function (item) {
        return item.split('=');
      }).map(function (_ref) {
        var _ref2 = babelHelpers.toArray(_ref),
            key = _ref2[0],
            value = _ref2.slice(1);

        return [key, value.join('=')].map(decodeURIComponent);
      }).reduce(function (obj, _ref3) {
        var _ref4 = babelHelpers.slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        obj[key] = value;
        return obj;
      }, {});

      if (cookieData["lastQuery"]) {
        var lastQuery = cookieData.lastQuery;

        try {
          lastQuery = JSON.parse(lastQuery);
        } catch (e) {
          lastQuery = {
            initialSort: "newest",
            initialFilter: "",
            query: lastQuery
          };
        }

        if (lastQuery) return lastQuery;
      }

      return {
        query: "",
        initialSort: "newest",
        initialFilter: ""
      };
    }
  }

  return qd[ident] || {
    query: "",
    initialFilter: "",
    initialSort: "newest"
  };
}

function setLastQueryForIdentifier(ident, q) {
  if (ident == 'search') {
    document.cookie = 'lastQuery=' + encodeURIComponent(JSON.stringify(q)) + '; path=/; max-age=86400; expires=' + new Date(Date.now() + 86400000).toGMTString();
  } else {
    qd[ident] = q ? Object.assign({}, q) : q;
  }
}

var searchResults = {};

function resetSearch() {
  searchResults = {};
}

function _doSearch(query) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof document !== 'undefined') {
    $(document).off('profileUpdated', resetSearch);
    $(document).on('profileUpdated', resetSearch);
    var qs = [];
    if (query) qs.push('query=' + encodeURIComponent(query));
    Object.keys(properties).forEach(function (prop) {
      if (Array.isArray(properties[prop])) {
        properties[prop].forEach(function (value) {
          qs.push("".concat(encodeURIComponent("".concat(prop, "[]")), "=").concat(encodeURIComponent(value)));
        });
      } else {
        qs.push("".concat(encodeURIComponent(prop), "=").concat(encodeURIComponent(properties[prop])));
      }
    });
    qs = qs.join('&');
    if (searchResults[qs]) return searchResults[qs];
    return searchResults[qs] = (0, _fetch.default)('data/search?' + qs).then(function (result) {
      return result.json();
    });
  }
}

var SearchControl = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(SearchControl, _Component);

  var _super = _createSuper(SearchControl);

  function SearchControl() {
    var _this;

    babelHelpers.classCallCheck(this, SearchControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "query", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "queryRan", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "initialSort", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "initialFilter", _descriptor4, babelHelpers.assertThisInitialized(_this));
    _this.state = {
      query: _this.query,
      queryRan: _this.queryRan,
      filter: JSON.stringify(_this.initialFilter),
      sort: _this.initialSort,
      animated: false,
      data: null,
      removedTag: false
    };
    return _this;
  }

  babelHelpers.createClass(SearchControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.doSearch();
    }
  }, {
    key: "doSearch",
    value: function doSearch() {
      var _this2 = this;

      if (this.props.doSearch) {
        var q = this.state.query;
        this.props.doSearch(this.state.query).then(function (result) {
          if (q == _this2.state.query) {
            _this2.setState({
              data: result.items
            });
          }
        });
        return;
      }

      var ps = this.getSearchProperties();

      if (this.state.query || Object.keys(ps).length) {
        var qp = _doSearch(this.state.query, ps);

        var q = this.state.query;
        qp.then(function (result) {
          if (_this2.state.query == q) {
            _this2.setState({
              data: result.items
            });
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.queryRan != this.state.queryRan) {
        var _this$state$sort;

        var q = lastQueryForIdentifier(this.props.id);
        q = Object.assign(q || {
          initialSort: (_this$state$sort = this.state.sort) !== null && _this$state$sort !== void 0 ? _this$state$sort : 'newest',
          initialFilter: JSON.parse(this.state.filter)
        }, {
          query: this.state.query || ""
        });
        q.query = this.state.query;

        if (!q.query) {
          q = null;
        }

        setLastQueryForIdentifier(this.props.id, q);
      }
    }
  }, {
    key: "removeTag",
    value: function removeTag() {
      this.setState({
        removedTag: true
      });
      this.doSearch();
    }
  }, {
    key: "getSearchProperties",
    value: function getSearchProperties() {
      var ps = Object.assign({}, this.props.searchProperties || {});
      if (this.state.removedTag) delete ps.tag;
      return ps;
    }
  }, {
    key: "autoFocus",
    value: function autoFocus(ref) {
      if (ref) ref.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "search-control"
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: "search-field",
        onSubmit: this.runSearch
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-input-group"
      }, this.getSearchProperties().tag ? /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "search-input-group-addon tag-button visible",
        onClick: this.removeTag
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "label"
      }), /*#__PURE__*/_react.default.createElement("span", null, this.getSearchProperties().tag), /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "clear"
      })) : null, /*#__PURE__*/_react.default.createElement("input", {
        placeholder: "What are you looking for?",
        className: "search-form-control",
        type: "text",
        ref: this.autoFocus,
        value: this.state.query,
        onChange: this.setQuery
      }), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _classList.default.join("search-input-group-addon-secondary", this.state.queryRan ? "visible" : ""),
        onClick: this.clearQuery
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "clear"
      })), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: _classList.default.join('search-input-group-addon', this.state.query ? "visible" : ""),
        onClick: this.runSearch
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "search"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-filters"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-type desktop"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Search for:"), /*#__PURE__*/_react.default.createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "search-type",
        value: "\"product\"",
        onChange: function onChange(ev) {
          return _this3.setFilter(ev.target.value);
        },
        checked: this.state.filter == '"product"'
      }), "Products"), /*#__PURE__*/_react.default.createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "search-type",
        value: "[\"document\",\"video\"]",
        onChange: function onChange(ev) {
          return _this3.setFilter(ev.target.value);
        },
        checked: this.state.filter == '["document","video"]'
      }), "Documents"), /*#__PURE__*/_react.default.createElement("label", {
        className: "radio-inline"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: "radio",
        name: "search-type",
        value: "null",
        onChange: function onChange(ev) {
          return _this3.setFilter(ev.target.value);
        },
        checked: this.state.filter == "null"
      }), "Both")), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-type mobile"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, /*#__PURE__*/_react.default.createElement("span", null, this.state.filter == '"product"' ? 'Products' : this.state.filter == '["document","video"]' ? 'Documents' : 'All', ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: "caret"
      }))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu"
      }, /*#__PURE__*/_react.default.createElement("li", {
        className: this.state.filter == '"product"' ? 'active' : ''
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick(event) {
          _this3.setFilter('"product"');

          event.preventDefault();
        }
      }, "Products")), /*#__PURE__*/_react.default.createElement("li", {
        className: this.state.filter == '["document","video"]' ? 'active' : ''
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick(event) {
          _this3.setFilter('["document","video"]');

          event.preventDefault();
        }
      }, "Documents")), /*#__PURE__*/_react.default.createElement("li", {
        className: this.state.filter == 'null' ? 'active' : ''
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: function onClick(event) {
          _this3.setFilter('null');

          event.preventDefault();
        }
      }, "All"))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-result-text"
      }, this.getSearchResultText()), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-result-sort"
      }, this.resultIsVisible ? this.renderSortMenu() : null))), /*#__PURE__*/_react.default.createElement("div", {
        className: _classList.default.join("search-result", Object.keys(this.getSearchProperties()).length || this.state.queryRan || this.props.doSearch ? "visible" : "", this.state.animated ? "animated" : "")
      }, this.state.data ? /*#__PURE__*/_react.default.createElement(_CatalogGroupPage.CatalogGroupPage, {
        newCards: true,
        className: "stack search catalog-group",
        sortOrder: this.state.sort,
        filter: JSON.parse(this.state.filter),
        includeUserSpecifiedSort: false,
        itemStyle: "cards",
        minimumSortMenuCount: 1,
        isSearchPage: true,
        query: null,
        tileList: this.state.data,
        keyValue: JSON.stringify([this.state.filter, this.state.sort]),
        key: JSON.stringify([this.state.filter, this.state.sort])
      }) : null));
    }
  }, {
    key: "resultIsVisible",
    get: function get() {
      if (this.state.data && (Object.keys(this.getSearchProperties()).length || this.state.queryRan || this.props.doSearch)) {
        return true;
      }

      return false;
    }
  }, {
    key: "renderSortMenu",
    value: function renderSortMenu() {
      var _this4 = this;

      var items = [{
        id: 'alpha',
        value: 'A-Z'
      }, {
        id: 'reverseAlpha',
        value: 'Z-A'
      }, {
        id: 'newest',
        value: 'Newest'
      }, {
        id: 'oldest',
        value: 'Oldest'
      }, {
        id: 'views',
        value: 'Most Viewed'
      }];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "input-group-btn dropdown sort-button"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn dropdown-toggle",
        "data-toggle": "dropdown"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Sort ", /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": "filter_list"
      }))), /*#__PURE__*/_react.default.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right"
      }, items.map(function (type) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: type.id,
          className: type.id == _this4.state.sort ? 'active' : ''
        }, /*#__PURE__*/_react.default.createElement("a", {
          href: "javascript:void(0)",
          onClick: function onClick(event) {
            _this4.setState({
              sort: type.id
            });

            event.preventDefault();
          }
        }, type.value));
      })));
    }
  }, {
    key: "getSearchResultText",
    value: function getSearchResultText() {
      if (this.state.data && (Object.keys(this.getSearchProperties()).length || this.state.queryRan || this.props.doSearch)) {
        var ft = JSON.parse(this.state.filter);

        if (!ft) {
          return "".concat(this.state.data.length, " item").concat(this.state.data.length == 1 ? '' : 's', " found");
        }

        if (ft) {
          var items = this.state.data.filter(function (item) {
            return Array.isArray(ft) ? ft.includes(item.type) : item.type == ft;
          });
          var type = ft == 'product' ? 'product' : 'document';
          return "".concat(items.length, " ").concat(type).concat(items.length == 1 ? '' : 's', " found");
        }
      }

      return '';
    }
  }, {
    key: "setSort",
    value: function setSort(sort) {
      this.setState({
        sort: sort
      });
      var q = lastQueryForIdentifier(this.props.id);
      q.initialSort = sort;
      setLastQueryForIdentifier(this.props.id, q);
    }
  }, {
    key: "setFilter",
    value: function setFilter(filter) {
      this.setState({
        filter: filter
      });
      var q = lastQueryForIdentifier(this.props.id);
      q.initialFilter = JSON.parse(filter);
      setLastQueryForIdentifier(this.props.id, q);
    }
  }, {
    key: "setQuery",
    value: function setQuery(event) {
      this.setState({
        query: event.target.value
      });
    }
  }, {
    key: "runSearch",
    value: function runSearch(event) {
      var _this5 = this;

      this.setState(function (st) {
        return {
          queryRan: true,
          animated: Object.keys(_this5.getSearchProperties()).length == 0 && !_this5.props.doSearch && st.queryRan != true,
          data: null
        };
      }, function () {
        var q = lastQueryForIdentifier(_this5.props.id);
        q = Object.assign(q || {
          initialSort: "newest",
          initialFilter: ""
        }, {
          query: _this5.state.query || ""
        });
        q.query = _this5.state.query;

        if (!q.query) {
          q = null;
        }

        setLastQueryForIdentifier(_this5.props.id, q);

        _this5.doSearch();
      });
      event.preventDefault();
      return false;
    }
  }, {
    key: "clearQuery",
    value: function clearQuery() {
      var _this6 = this;

      this.setState(function (st) {
        return {
          query: "",
          queryRan: false,
          animated: Object.keys(_this6.getSearchProperties()).length == 0 && !_this6.props.doSearch && st.queryRan != false
        };
      }, function () {
        if (Object.keys(_this6.getSearchProperties()).length) _this6.doSearch();
      });
    }
  }], [{
    key: "getControl",
    value: function getControl(identifier) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (identifier == 'events') props.initialSort = 'oldest';
      return /*#__PURE__*/_react.default.createElement(SearchControl, _extends({
        id: identifier
      }, lastQueryForIdentifier(identifier), props, {
        queryRan: !!lastQueryForIdentifier(identifier).query
      }));
    }
  }]);
  return SearchControl;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "query", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "queryRan", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "initialSort", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "newest";
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "initialFilter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "null";
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "removeTag", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "removeTag"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "autoFocus", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "autoFocus"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setSort", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setSort"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setFilter", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setFilter"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setQuery", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setQuery"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "runSearch", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "runSearch"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "clearQuery", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "clearQuery"), _class.prototype)), _class);
exports.default = SearchControl;